import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import $ from 'jquery';
import classnames from 'classnames';

const GLOBAL = require('../../Globals');

class LessonPlanning extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			cls : '',
			section : '',
			subject : '',
			lect : '',
			topic : '',
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			secs : [],
			subj : [],
			id : '',
			data : [],
			activeTab: '1'
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** reset Subject Allocated form **/
	onClick(e){
		
		document.getElementById("suballform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.lect && this.state.topic && this.state.cls && this.state.section && this.state.subject){
			
			PostData('academic/addlessplaning',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Lesson Planning added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("suballform").reset();
					this.getdata();	
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getclass();
		this.getdata();	
	}
	
	getdata(){
		
		GetData('academic/getlessplan').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('academic/deletelesplan',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'LessonPlanning Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove LessonPlanning',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	
  render() {
	
	var items = this.state.posts;
	  
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'section/getsectsbyclass/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});
			
		},'json');
	
	});
	
	/** get Subject By Class & Section **/
	$("#secs").change(function(){
		var cr = $("#clas").val();
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'subjectallocation/getsubjectbysec/'+cr+'/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#sub").html('');
			$('#sub')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Subject- ')); 
			$.each(o,function(key,value){			
				   $('#sub')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.subname)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
  
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
        <Row>
          <Col md="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  Lesson Planning
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Report
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
				<Row>
				<Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="suballform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Lesson Planning</strong>
					</CardHeader>
					<CardBody>
					  <Row>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" onChange={this.onChange} className="form-control" id="clas" required> 
															<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <select name="section" onChange={this.onChange} className="form-control" id="secs" required>
															
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
							  <select name="subject" onChange={this.onChange} className="form-control" id="sub" required>
															
							  </select>
							</FormGroup>
						</Col>
						<Row id="lecture">
						  <Col md="6">
							<FormGroup>
								<Input type="text" name="lect" required placeholder="Lecture Code" onChange={this.onChange} />
							</FormGroup>
						  </Col>
						   <Col md="6">
							<FormGroup>
								<Input type="text" name="topic" required placeholder="Topic" onChange={this.onChange} />
							</FormGroup>
						  </Col>
						</Row>
					  </Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
				</Col>
				<Col md="7">
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Class</th>
								<th>Section</th>
								<th>Subject</th>
								<th>Lecture Code</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.cls}</td>
									<td>{item.sec}</td>
									<td>{item.sub} - {item.topic}</td>
									<td>{item.lecturecode}</td>
									<td>
										<button name="view" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-eye"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
				</Col>
				</Row>
			  </TabPane>
			  <TabPane tabId="2">
				<Row>
				<Col md="6">
				
				</Col>
				<Col md="6">
					
				</Col>
				</Row>
			  </TabPane>
			</TabContent>
		  </Col>
		</Row>
		</div>
	);
  }
}

export default LessonPlanning;


// WEBPACK FOOTER //
// ./src/plan/Lesson/LessonPlanning.js